import { fail, success } from '@helpers/result-helper.js'
import { isSuccess } from '@/helpers/http-status-helpers'
import toast from '@services/toasts/index.js'

// eslint-disable-next-line no-unused-vars
import OverdueInvoicesByClientViewModel from '@/models/finance/overdueInvoicesByClientViewModel'
// eslint-disable-next-line no-unused-vars
import GenerateOverdueInvoiceChargesDTO from '@/models/finance/generateOverdueInvoiceChargesDTO'
// eslint-disable-next-line no-unused-vars
import InvoiceCenterViewModel from '@/models/finance/invoiceCenterViewModel'
// eslint-disable-next-line no-unused-vars
import GenerateOverdueInvoiceChargesResult from '@/models/finance/generateOverdueInvoiceChargesResult'
// eslint-disable-next-line no-unused-vars
import InvoiceCenterIdentifier from '@/constants/finance/InvoiceCenterIdentifier'

const getDefaultState = () => {
  return {
    // Place any new state properties here
    loadingCount: 0,
    crudLoadingCount: 0,
    currentInvoiceCenter: null,
  }
}

const state = getDefaultState()

export default {
  namespaced: true,
  /**
   * @typedef {{
   * loadingCount: number
   * crudLoadingCount: number
   * currentInvoiceCenter: InvoiceCenterViewModel
   * }} FinanceState
   * @type {FinanceState}
   */
  state,
  getters: {
    /**
     * @returns {Boolean}
     */
    isLoading: (state) => state.loadingCount > 0,
    /**
     * @returns {Boolean}
     */
    isLoadingCRUD: (state) => state.crudLoadingCount > 0,
    /**
     * @returns {InvoiceCenterViewModel}
     */
    currentInvoiceCenter: (state) => state.currentInvoiceCenter,
    /**
     * @returns {String}
     */
    currentInvoiceCenterLocale: (state) =>
      state.currentInvoiceCenter === null
        ? null
        : state.currentInvoiceCenter.optionalExtras.currencyCulture,
    /**
     * @returns {String}
     */
    currentInvoiceCenterTimeZone: (state) =>
      state.currentInvoiceCenter === null
        ? null
        : state.currentInvoiceCenter.timeZone,
  },
  mutations: {
    START_LOADING(state) {
      state.loadingCount++
    },
    FINISH_LOADING(state) {
      state.loadingCount--
    },
    START_LOADING_CRUD(state) {
      state.crudLoadingCount++
    },
    FINISH_LOADING_CRUD(state) {
      state.crudLoadingCount--
    },
    CLEAR_STORE(state) {
      // Resets store to default state
      Object.assign(state, getDefaultState())
    },
    /**
     * Sets the current Invoice Center
     * @param {InvoiceCenterViewModel} invoiceCenter
     */
    SET_CURRENT_INVOICE_CENTER(state, invoiceCenter) {
      state.currentInvoiceCenter = invoiceCenter
    },
    /**
     * Clears the current Invoice Center
     */
    CLEAR_CURRENT_INVOICE_CENTER(state) {
      state.currentInvoiceCenter = null
    },
  },
  actions: {
    /**
     * @param {InvoiceCenterIdentifier} invoiceCenterID
     * @returns {InvoiceCenterViewModel}
     */
    async getInvoiceCenterByID(context, invoiceCenterID) {
      try {
        const response = await this.$api.finance.getInvoiceCenterByID(
          invoiceCenterID
        )
        if (isSuccess(response.status)) {
          return success(response.data)
        }
      } catch (ex) {
        toast.error(
          this.$i18n.t(
            'finance.overdueInvoices.errorMessages.failedToLoadInvoiceCenter'
          )
        )
        return fail()
      }
    },
    /**
     * @param {InvoiceCenterIdentifier} invoiceCenterID
     * @param {Number} dueDateUTC
     * @returns {OverdueInvoicesByClientViewModel[]}
     */
    async getOverdueInvoicesByClient(context, { invoiceCenterID, dueDateUTC }) {
      try {
        const response = await this.$api.finance.getOverdueInvoicesByClient(
          invoiceCenterID,
          dueDateUTC
        )
        if (isSuccess(response.status)) {
          return success(response.data)
        }
      } catch (ex) {
        toast.error(
          this.$i18n.t(
            'finance.overdueInvoices.errorMessages.failedToLoadOverdueInvoices'
          )
        )
        return fail()
      }
    },
    /**
     * @param {GenerateOverdueInvoiceChargesDTO} payload
     * @returns {GenerateOverdueInvoiceChargesResult}
     */
    async generateOverdueInvoiceCharges(context, payload) {
      try {
        const response = await this.$api.finance.generateOverdueInvoiceCharges(
          payload
        )
        if (isSuccess(response.status)) {
          toast.success('Interest Charges created.')
          return success(response.data)
        }
      } catch (ex) {
        toast.error(
          this.$i18n.t(
            'finance.overdueInvoices.errorMessages.failedToGenerateInterestCharges'
          )
        )
        return fail()
      }
    },
    /**
     * Resets store to default state.
     */
    clear({ commit }) {
      commit('CLEAR_STORE')
    },
  },
}
